import { cn } from 'lib/utils';

export type BloomProps = {
  className?: string;
  positionX?: 'left' | 'center' | 'right';
  positionY?: 'top' | 'center' | 'bottom';
  size?: 'md' | 'lg';
  variant?: 'athletic' | 'blue';
};

// TODO: Move this into Tailwind? (or remove this comment otherwise)
const bloomVariantStyles = {
  athletic: {
    background:
      'radial-gradient(50% 50% at 50% 50%, rgba(105, 165, 255, 0.24), rgba(105, 165, 255, 0.11) 50%, rgba(105, 165, 255, 0))',
  },
  blue: {
    background:
      'radial-gradient(50% 50% at 50% 50%, rgba(47, 75, 115, 0.24), rgba(47, 75, 115, 0.11) 50%, rgba(47, 75, 115, 0))',
  },
};

const Bloom = ({
  className,
  positionX,
  positionY,
  size = 'md',
  variant = 'blue',
}: BloomProps) => {
  if (!positionX || !positionY) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute pointer-events-none',
        {
          // Positions
          'left-1/2 -translate-x-1/2': positionX === 'center',
          'top-1/2 -translate-y-1/2': positionY === 'center',
          'left-0 -translate-x-1/2': positionX === 'left',
          'right-0 translate-x-1/2': positionX === 'right',
          'top-0 -translate-y-1/2': positionY === 'top',
          'bottom-0 translate-y-1/2': positionY === 'bottom',

          // Sizes (clamp = 400px - 1440px)
          'w-[clamp(27.5rem,3.462rem+96.154vw,90rem)] h-[clamp(31.25rem,24.038rem+28.846vw,50rem)]':
            size === 'md',
          'w-[clamp(44rem,14.769rem+116.923vw,120rem)] h-[clamp(25rem,8.654rem+65.385vw,67.5rem)]':
            size === 'lg',
        },
        className
      )}
      style={bloomVariantStyles[variant]}
      aria-hidden="true"
    />
  );
};

export default Bloom;
